import { LOGOUT_SUCCESS } from '../actions/logout';
import api from '../api';

const PROGRESS_LIST_SUCCESS = api.events.progressList.actionSuccess;
const PROGRESS_CREATE_SUCCESS = api.events.progressCreate.actionSuccess;
const PROGRESS_DELETE_SUCCESS = api.events.progressDelete.actionSuccess;

const defaultState = { current: null, all: [] };

export default function(state = defaultState, action) {
  switch (action.type) {
    case PROGRESS_CREATE_SUCCESS: {
      const { chapterId, topicId } = action.data;
      
      // Check if state has any record for this chapter/module
      if (!state.all.includes(module => chapterId === module.chapterId)) {
        state.all.push({
          chapterId,
          topics: []
        });
      }
      const all = state.all.map(module => {
        // If not this module return
        if (chapterId !== module.chapterId) {
          return module;
        }
        // If a record for this already exists, return
        if (module.topics.includes(topic => topicId === topic.topicId)) {
          return module;
        }

        // Return a new object with the new topic
        return { ...module, topics: [...module.topics, { topicId }], updatedAt: action.data.updatedAt };
      });
      return {
        current: action.data,
        all
      };
    }

    case PROGRESS_DELETE_SUCCESS: {
      const { chapterId, topicId } = action.data;
      const all = state.all.map(module => {
        // If not this module return
        if (chapterId !== module.chapterId) {
          return module;
        }
        // Filter out the topic from progress
        return {
          ...module,
          topics: module.topics.filter(topic => topicId !== topic.topicId)
        };
      });
      return {
        all
      };
    }

    case PROGRESS_LIST_SUCCESS:
      return { all: action.data };

    case LOGOUT_SUCCESS:
      return defaultState;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/progress.js